import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.2/js/sparta-events-utility";
import spartaMediaQueryUtility from "utilities/global/sparta-mediaquery-utility/2.0.2/js/sparta-mediaquery-utility";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.0.3/js/sparta-store-utility";
import spartaStyleUtility from "utilities/global/sparta-style-utility/3.1.5/js/sparta-style-utility";
import Module from "utilities/global/sparta-module-utility/6.2.5/js/sparta-module-utility";
import spartaStickyUtility from "utilities/global/sparta-sticky-utility/4.0.4/js/sparta-sticky-utility";
import helpersComparisons from "utilities/helpers/helpers-comparisons/1.0.1/js/helpers-comparisons";
import helperComparisons from "utilities/helpers/helpers-comparisons/1.0.1/js/helpers-comparisons";
import TaglineHelper from "utilities/helpers/helpers-tagline/1.0.0/js/tagline-helper";
import handlebarsRuntime from "utilities/vendor/handlebars-runtime/4.7.6/js/handlebars.runtime";
import hb from "utilities/vendor/handlebars-runtime/4.7.6/js/handlebars.runtime";
import MenuNav from "modules/global/global-nav-module/10.0.5/js/menu-nav";
import spartaTemplates from "modules/global/global-nav-module/10.0.5/js/templates";
import "css!modules/global/global-nav-module/10.0.5/css/global-nav-module.scss.css";
import "css!modules/global/global-nav-module/10.0.5/css/search-stub-overwrite.scss.css";
import "css!modules/global/global-nav-module/10.0.5/css/menu-nav.scss.css";









const selectors = {
  header: '.header',
  menuButton: '.js-menu-button',
};

const cssModifiers = {
  open: 'header--open',
};

const events = {
  menuButtonClicked: 'GLOBAL_NAV_MODULE_MENU_BUTTON.clicked',
  navigationCollapsed: 'MENU_NAV_MODULE_NAVIGATION.collapsed',
};







export default class GlobalNavModuleJS extends Module {




  init() {
    const headerModuleElement = this.settings.target;
    const menuButtonElement = headerModuleElement.querySelector(selectors.menuButton);
    if (menuButtonElement) {
      menuButtonElement.addEventListener('click', this.menuButtonClick.bind(this));
      MenuNav.init(this.settings.target);
    }
  }







  menuButtonClick(event) {
    const header = this.settings.target.querySelector(selectors.header);


    header.classList.toggle(cssModifiers.open);

    this.Events.pub(events.menuButtonClicked);

    GlobalNavModuleJS.setAriaExpanded({
      referenceElem: header,
      targetElem: event.currentTarget,
      invert: false,
    });
  }









  static setAriaExpanded({ referenceElem, targetElem, invert }) {
    GlobalNavModuleJS.syncAttrClass({
      referenceElem,
      targetElem,
      attr: 'aria-expanded',
      className: cssModifiers.open,
      invert,
    });
  }













  static syncAttrClass({
    referenceElem,
    targetElem,
    attr,
    className,
    invert,
  }) {
    let attrVal = referenceElem.classList.contains(className);

    if (invert) {
      attrVal = !attrVal;
    }

    targetElem.setAttribute(attr, attrVal);
  }
}
